// extracted by mini-css-extract-plugin
export default {"full-screen-popup":"full-screen-popup_full-screen-popup__Cx531","no-padding":"full-screen-popup_no-padding__rnLf8","content":"full-screen-popup_content__2UjCZ"};